import { useState } from 'react'
import OverviewTab from './tabs/OverviewTab'
import PipelineHealthTab from './tabs/PipelineHealthTab'
import DataSourcesTab from './tabs/DataSourcesTab'
import { TimeWindow } from '../../../types/dataQuality'
import './DataTrustQuality.css'

const DataTrustQuality = () => {
  const [activeTab, setActiveTab] = useState<'overview' | 'pipeline-health' | 'data-sources'>('overview')
  const [timeWindow, setTimeWindow] = useState<TimeWindow>(TimeWindow.WEEK)
  const [overviewRefreshKey, setOverviewRefreshKey] = useState(0)
  const [pipelineRefreshKey, setPipelineRefreshKey] = useState(0)
  const [dataSourcesRefreshKey, setDataSourcesRefreshKey] = useState(0)

  const handleTabChange = (tab: 'overview' | 'pipeline-health' | 'data-sources') => {
    setActiveTab(tab)
    
    // Increment refresh key for the selected tab to force fresh data fetch
    if (tab === 'overview') {
      setOverviewRefreshKey(prev => prev + 1)
    } else if (tab === 'pipeline-health') {
      setPipelineRefreshKey(prev => prev + 1)
    } else if (tab === 'data-sources') {
      setDataSourcesRefreshKey(prev => prev + 1)
    }
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case 'overview':
        return <OverviewTab key={`overview-${overviewRefreshKey}-${timeWindow}`} timeWindow={timeWindow} onTimeWindowChange={setTimeWindow} />
      case 'pipeline-health':
        return <PipelineHealthTab key={`pipeline-${pipelineRefreshKey}-${timeWindow}`} timeWindow={timeWindow} onTimeWindowChange={setTimeWindow} />
      case 'data-sources':
        return <DataSourcesTab key={`datasources-${dataSourcesRefreshKey}-${timeWindow}`} timeWindow={timeWindow} onTimeWindowChange={setTimeWindow} />
      default:
        return <OverviewTab key={`overview-default-${overviewRefreshKey}-${timeWindow}`} timeWindow={timeWindow} onTimeWindowChange={setTimeWindow} />
    }
  }

  return (
    <div className="data-trust-quality-container">
      {/* Tab Navigation Section - Separate Container */}
      <div className="tab-navigation-section">
        <div className="tab-navigation-padding">
          <div className="tab-navigation-flex">
            {/* Tab Buttons */}
            <div className="tab-buttons-container">
              {/* Overview Tab */}
              <button
                onClick={() => handleTabChange('overview')}
                className={`tab-button ${activeTab === 'overview' ? 'active' : ''}`}
              >
                <svg className="tab-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                  <line x1="9" y1="9" x2="15" y2="9"/>
                  <line x1="9" y1="15" x2="15" y2="15"/>
                </svg>
                <span>Data Health Overview</span>
              </button>

              {/* Pipeline Health Tab */}
              <button
                onClick={() => handleTabChange('pipeline-health')}
                className={`tab-button ${activeTab === 'pipeline-health' ? 'active' : ''}`}
              >
                <svg className="tab-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
                </svg>
                <span>Pipeline Health</span>
              </button>

              {/* Data Sources Tab */}
              <button
                onClick={() => handleTabChange('data-sources')}
                className={`tab-button ${activeTab === 'data-sources' ? 'active' : ''}`}
              >
                <svg className="tab-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <ellipse cx="12" cy="5" rx="9" ry="3"/>
                  <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
                  <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
                </svg>
                <span>Source Health</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section - Separate Container */}
      <div className="content-section">
        {/* Tab Content */}
        <div className="tab-content">
          {renderTabContent()}
        </div>
      </div>
    </div>
  )
}

export default DataTrustQuality